import { Component, OnInit, Inject } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { OrganizationModel } from '@synthroneApp/models/organization/organization.model';
import { ApiService, MessagesService } from '@angular/synthrone-design/services';
import { APP_CONFIG } from '@synthroneApp/app.config';
import { MatDialog } from '@angular/material';
import { CustomProductSectionsEditorComponent } from '@synthroneApp/components/forms/custom-product-sections-editor/custom-product-sections-editor.component';
import { ClientServiceSDK, ApplicationServiceSDK } from 'ms-client-angular-sdk';

@Component({
  selector: 'app-organization-add-view',
  templateUrl: './organization-add-view.component.html',
  styleUrls: ['./organization-add-view.component.scss']
})

export class OrganizationAddViewComponent implements OnInit {

  isDataLoading: number = 0;
  orgPlanet: any;
  actionName: string;
  applications: any;
  public organization: OrganizationModel;
  isUsersDeactivation: boolean;
  defaultObject = {};
  customProductSectionsAsString: string;
  parentOrganizations: any;
  isThisParent: boolean = false;

  sections = [
    'synthroneBasic',
    'synthroneBasicLp',
    'synthroneRich',
    'synthroneAttributes',
    'synthroneLogistics',
    'synthroneOrganizationSpecifics',
    'synthroneRatingsAndReviews',
    'synthroneUpSell',
    'synthroneCrossSell',
    'synthroneFaqs',
    'synthroneVariants',
    'synthronePlatforms'
  ];

  constructor(
    private _router: Router,
    protected api: ApiService,
    private messagesService: MessagesService,
    @Inject(APP_CONFIG) private config,
    protected dialog: MatDialog,
    private clientService: ClientServiceSDK,
    private applicationService: ApplicationServiceSDK
  ) {
    this.actionName = (this._router.url.includes('add') ? 'Add' : 'Edit');

    for (let i = 0; i < this.sections.length; i++) {
      this.defaultObject[this.sections[i]] = {'customLabel': {'icon': null, 'title': null}, 'visibility': true, 'customTemplate': false};
    }
  }

  ngOnInit() {
    this.applications = [];

    this.organization = {
      adminUser: {
        name: '',
        email: '',
        password: '',
        repeatPassword: ''
      },
      name: '',
      assets: {
        logo: false,
        background: false,
        theme: ''
      },
      customProductSections: {},
      planet: '',
      configuration: {
        userInactivityLimit: null,
        storageLimit: null,
        syndicationLimit: null,
        syndicationTransferLimit: null,
        usersLimit: null,
        templatePrefix: null
      },
      applications: [],
      parent: null
    };
    this.isDataLoading++;

    this.applicationService.applicationsGet().catch(
      (err: any) => {
        let errorMsg = err || 'Could not get list of applications';
        return Observable.throw(errorMsg)
      }).subscribe(
      (result) => {
        this.applications['data'] = Object.keys(result).map(k => Object.assign({}, result[k], {id: parseInt(k)}));
        this.isDataLoading--;
      },
      (error) => {
        this.isDataLoading--;
        this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
          this.messagesService.showSnack(parsedError, 'error').afterDismissed().subscribe(result => {
            this.homeReturnFN();
          });
        });
        });

    if (this.actionName === 'Edit') {
      this.isDataLoading++;
      this.orgPlanet = (this._router.url).split('edit/')[1];
      this.clientService.clientPlanetGet(this.orgPlanet).subscribe(
        (result) => {
          this.isUsersDeactivation = !!(result['configuration'] && result['configuration']['userInactivityLimit']);

          this.isDataLoading--;

          this.organization = {
            adminUser: result['adminUser'],
            name: result['name'],
            planet: result['planet'],
            applications: !result['applications'] ? [] : result['applications'],
            configuration: {
              storageLimit: !(result['configuration'] && result['configuration']['storageLimit']) ? null : result['configuration']['storageLimit'],
              userInactivityLimit: !(result['configuration'] && result['configuration']['userInactivityLimit']) ? null : result['configuration']['userInactivityLimit'],
              templatePrefix: !(result['configuration'] && result['configuration']['templatePrefix']) ? null : result['configuration']['templatePrefix'],
              syndicationLimit: !(result['configuration'] && result['configuration']['syndicationLimit']) ? null : result['configuration']['syndicationLimit'],
              syndicationTransferLimit: !(result['configuration'] && result['configuration']['syndicationTransferLimit']) ? null : result['configuration']['syndicationTransferLimit'],
              usersLimit: !(result['configuration'] && result['configuration']['usersLimit']) ? null : result['configuration']['usersLimit']
            },
            customProductSections: !result['customProductSections'] || (result['customProductSections'] && Object.keys(result['customProductSections']).length === 0) ? (window as any).structuredClone(this.defaultObject) : (window as any).structuredClone(result['customProductSections']),
            parent: !result['parent'] ? null : result['parent']
          };

          this.customProductSectionsAsString = JSON.stringify(this.sortObject(this.organization.customProductSections));
          this.compareObjects();
        },
        (error) => {
          this.isDataLoading--;
          this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
            this.messagesService.showSnack(parsedError, 'error').afterDismissed().subscribe(result => {
              this.homeReturnFN();
            });
          });
        });
    } else if (this.actionName === 'Add') {
      this.organization.customProductSections = (window as any).structuredClone(this.defaultObject);
      this.customProductSectionsAsString = JSON.stringify(this.sortObject(this.organization.customProductSections));
    }

    this.clientService.clientsGet().catch(
      (err: any) => {
        let errorMsg = err || 'Could not get list of organizations';
        return Observable.throw(errorMsg)
      }).subscribe(
        (result) => {
          let clients = Object.keys(result).map(k => Object.assign({}, result[k], { id: parseInt(k) }));
          this.parentOrganizations = clients.filter(org => !org.parent).filter(org => org.features.some(f => f.name === 'synthrone.manager.brandconnect.dashboard'));
          this.isDataLoading--;
          if (this.actionName === 'Edit') {
            this.isThisParent = (this.parentOrganizations.some(org => org.planet === this.organization.planet) || clients.some(org => org.parent === this.organization.planet));
            if (!this.isThisParent) {
              this.parentOrganizations = this.parentOrganizations.filter(org => org.planet !== this.organization.planet);
            }
          }
        },
        (error) => {
          this.isDataLoading--;
          this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
            this.messagesService.showSnack(parsedError, 'error').afterDismissed().subscribe(result => {
              this.homeReturnFN();
            });
          });
        });
  }

  homeReturnFN = () => {
    this._router.navigate(['/organizations']);
  }

  createOrgFN = () => {
    this.clientService.clientPost(this.prepareForRequest()).subscribe(
      (result) => {
        this.isDataLoading--;
        this._router.navigate(['/organizations']);
      },
      (error) => {
        this.isDataLoading--;
        this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
          this.messagesService.showSnack(parsedError, 'error');
        });
      });
  }

  editOrgFN = () => {
    this.isDataLoading++;
    this.clientService.clientPlanetPatch(this.organization.planet, this.prepareForRequest()).subscribe(
      (result) => {
        this.isDataLoading--;
        this._router.navigate(['/organizations']);
      },
      (error) => {
        this.isDataLoading--;
        this.api.errorCallback(error).subscribe(() => { }, (parsedError) => {
          this.organization.customProductSections = (window as any).structuredClone(this.organization.customProductSections);
          this.messagesService.showSnack(parsedError, 'error');
        });
      });
  }

  submitFN (isValid: boolean) {
    if (!this.isUsersDeactivation) {
      this.organization.configuration['userInactivityLimit'] = null;
    }

    if (!this.organization.configuration.templatePrefix) {
      this.organization.configuration.templatePrefix = null;
    }

    this.actionName === 'Add' ? this.createOrgFN() : this.editOrgFN();
  }

  specificationEditor = (event) => {
    event.preventDefault();
    this.openModal();
  };

  compareObjects = () => {
    if (this.organization.configuration.templatePrefix) {
      return false;
    }

    return JSON.stringify(this.organization.customProductSections) === JSON.stringify(this.defaultObject);
  }

  setDefaultCustomProductSections = () => {
    this.organization.customProductSections = (window as any).structuredClone(this.defaultObject);
    this.customProductSectionsAsString = JSON.stringify(this.sortObject(this.organization.customProductSections));
    this.organization.configuration.templatePrefix = null;
  }

  openModal = () => {
    this.dialog.open(CustomProductSectionsEditorComponent, {
      data: [(window as any).structuredClone(this.organization.customProductSections), (window as any).structuredClone(this.organization.configuration.templatePrefix), (window as any).structuredClone(this.defaultObject)]
    }).afterClosed().subscribe(result => {
      if (result) {
        this.organization.customProductSections = Object.assign({}, result[0]);
        this.organization.configuration.templatePrefix = result[1];
        this.customProductSectionsAsString = JSON.stringify(this.sortObject(this.organization.customProductSections));
        this.compareObjects();
      }
    });
  }

  prepareForRequest = () => {
    Object.keys(this.organization.customProductSections).forEach( key => {
      if (this.organization.customProductSections[key] && this.organization.customProductSections[key]['visibility']) {
        this.organization.customProductSections[key]['visibility'] = true;
      }
      if (this.organization.customProductSections[key] && this.organization.customProductSections[key]['customTemplate']) {
        this.organization.customProductSections[key]['customTemplate'] = true;
      }
    })
    return this.organization;
  }

  sortObject = (obj) => {
    let sortedObj = {}
    Object.keys(obj).sort().map(x=>{ sortedObj[x] = obj[x] })
    return sortedObj;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/views/organization-add-view/organization-add-view.component.ts